import SharedLibLineItemUnitPrice from 'payments-checkout-lib/components/LineItems/LineItemUnitPrice';
import CustomQuantityInput from '../CustomQuantityInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LineItemQuantityAndUnitPrice({
  id,
  currencyCode,
  pricing,
  effectiveUnitPrice,
  quantity,
  quantityMax,
  quantityMin,
  isEditable,
  error
}) {
  return /*#__PURE__*/_jsx(SharedLibLineItemUnitPrice, {
    currencyCode: currencyCode,
    pricing: pricing,
    effectiveUnitPrice: effectiveUnitPrice,
    quantity: quantity,
    QuantityComponent: isEditable ? /*#__PURE__*/_jsx(CustomQuantityInput, {
      quantity: quantity,
      id: id,
      min: quantityMin,
      max: quantityMax,
      error: error
    }) : null
  });
}